import { apiClient } from '@/libs/api'

export type DeleteShipmentOrderHistoryParams = {
  tenantKey: string
  id: number
}

/**
 * 配送依頼入力履歴削除API
 */
export const deleteShipmentOrderHistory = async ({
  tenantKey,
  id
}: DeleteShipmentOrderHistoryParams): Promise<void> => {
  await apiClient._tenant(tenantKey).shipment_orders.histories._id(id).$delete()
}
